'use strict';

window.CFC = window.CFC || {};
window.CFC.Archive = (function($) {
  function init() {
    $('.article--archive').on('click', '[data-card-pager-number]', function(e) {
      e.preventDefault();
      
      var rawUrl = this.href.split('?')[0];
      var page = this.dataset.cardPagerNumber;
      var loadButton = this;
      this.dataset.cardPagerNumber++;
      
      var pageUrl = rawUrl + '?page=' + page + '&card-pager-mode=content'

      window.fetch(pageUrl)
        .then(function(response) { return response.text(); })
        .then(function(body) {
          var $archive = $('.archiveGrid').append(body);
          var $loadButton = $(loadButton).closest('.inlineButton__wrap');
          var $newLoadButton = $archive.find('.archive__loadButton').closest('.inlineButton__wrap');
          
          if ($newLoadButton.length) {
            $newLoadButton.detach();
            $loadButton.replaceWith($newLoadButton);
          }
          else {
            $loadButton.remove();
          }
        });
    });
  }
  
  $(init);
})(jQuery);
